define({
    copySuccess: '复制成功',
    copyFail: '复制失败',
    day:'天',
    hour:'时',
    minute:'分',
    second:'秒'
});